module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-LightCondIt.95c1794.ttf";